var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTherapiesSuggested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 184,
    viewBox: "0 0 185 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4674_12918)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4674_12918",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 185,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499023 1.52588e-05H184.499V184H0.499023V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4674_12918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4984 86.492C92.4984 93.8182 90.2354 99.5887 82.9469 99.487C77.6458 99.4136 73.1105 96.562 71.1289 91.9476C70.892 91.396 70.3598 91.0434 69.7618 91.0449H69.7234C60.6527 91.0449 55.2909 86.0445 55.2909 76.9286C55.2909 75.8523 55.3944 74.8004 55.5906 73.7823C55.7088 73.1653 55.4328 72.5425 54.8891 72.2298C48.1077 68.3256 45.4961 63.4165 45.4961 54.9985C45.4961 46.5808 48.1077 41.6703 54.8891 37.7672C55.4328 37.4545 55.7088 36.8317 55.5906 36.214C55.3944 35.1955 55.2909 34.1447 55.2909 33.0683C55.2909 23.9524 60.6527 18.9521 69.7234 18.9521H69.7618C70.3598 18.9535 70.892 18.601 71.1289 18.0483C73.1105 13.435 77.6458 10.5837 82.9469 10.51C90.2361 10.4083 92.4984 16.1788 92.4984 23.505",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.498 23.505C92.498 16.1788 94.761 10.4083 102.05 10.51C107.351 10.5833 111.886 13.435 113.868 18.0494C114.104 18.601 114.637 18.9535 115.235 18.9521H115.273C124.344 18.9521 129.706 23.9524 129.706 33.0683C129.706 34.1447 129.602 35.1966 129.406 36.2147C129.288 36.8317 129.564 37.4545 130.107 37.7672C136.889 41.6714 139.5 46.5809 139.5 54.9985C139.5 63.4165 136.889 68.3266 130.107 72.2298C129.564 72.5425 129.288 73.1653 129.406 73.783C129.602 74.8015 129.706 75.8523 129.706 76.9286C129.706 86.0445 124.344 91.0449 115.273 91.0449H115.235C114.637 91.0434 114.104 91.396 113.868 91.9487C111.886 96.562 107.351 99.4133 102.05 99.487C94.7603 99.5887 92.498 93.8182 92.498 86.492",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.365 18.7567C113.03 23.7764 107.899 26.7585 102.904 25.417",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.503 91.1133C110.429 90.019 108.009 85.8125 109.098 81.7181",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6309 91.25C71.9656 86.2303 77.0971 83.2482 82.092 84.5897",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4932 18.89C74.5674 19.9843 76.9874 24.1908 75.8989 28.2852",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3644 63.1758C67.2501 63.0615 67.138 62.9454 67.0287 62.8283C62.9254 58.4259 66.0958 51.2399 72.1139 51.2399",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.633 63.1758C117.747 63.0615 117.859 62.9454 117.968 62.8283C122.072 58.4259 118.901 51.2399 112.883 51.2399",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.498 23.5054V86.7812",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25 79.4727V52.3621C153.25 48.3328 156.516 45.0657 160.546 45.0657C160.585 45.0657 160.795 45.0701 160.8 45.0701C162.485 45.1279 164.025 45.7568 165.232 46.7692",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7469 79.4727V52.3621C31.7469 48.3328 28.4806 45.0657 24.4505 45.0657C24.4121 45.0657 24.2019 45.0701 24.1968 45.0701C22.5121 45.1279 20.9721 45.7568 19.7646 46.7692",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8714 118.487L20.5427 91.9907C18.6836 90.1033 17.9469 87.5298 18.3261 85.0986C18.5776 83.4843 19.3212 81.9325 20.5553 80.6859C20.5793 80.6614 21.2003 80.1004 21.2021 80.099C24.3826 77.5097 29.0706 77.7174 32.0067 80.6981L57.8713 106.184C64.5226 112.738 68.268 121.686 68.268 131.024V173.484H43.0068V143.233L13.6466 119.55C7.78163 114.16 4.25042 106.633 4.0984 98.6683C4.09337 98.4056 4.09121 98.1414 4.09193 97.8755C4.12571 85.7139 4.17818 46.1377 4.17818 37.5396C4.17818 33.9606 7.96815 31.3663 11.7132 31.5424C15.6376 31.7271 18.657 35.1078 18.657 39.0368V83.6852",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.687 105.268L164.454 91.9907C166.313 90.1033 167.05 87.5298 166.67 85.0986C166.419 83.4843 165.675 81.9325 164.441 80.6862C164.417 80.6614 163.796 80.1004 163.794 80.099C160.614 77.5097 155.926 77.7174 152.99 80.6981L127.125 106.184C120.474 112.738 116.729 121.686 116.729 131.024V173.484H141.99V143.233L171.35 119.551C177.215 114.16 180.746 106.633 180.898 98.6682C180.903 98.4055 180.905 98.1414 180.905 97.8755C180.871 85.7139 180.818 46.1377 180.818 37.5396C180.818 33.961 177.028 31.3663 173.283 31.5427C169.359 31.7271 166.34 35.1077 166.34 39.0372V83.6852",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4674_12918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapiesSuggested);
export default __webpack_public_path__ + "static/media/therapiesSuggested.bb527536fe17f695d1b64fca544a884d.svg";
export { ForwardRef as ReactComponent };